import List from 'ln/list/List';
import CustomBase from './CustomBase';
import UserFileModel from './UserFileModel';
import { backend } from '../../setup';
import { ISlide } from '../slideview/SlideDetailView';


class CustomUserSequenceModel extends CustomBase {

	constructor( json:Object ){
		super( json );	
	}

	static getInstance(){
		return new CustomUserSequenceModel({  
			origin: null,
			time: 15,
			done: false,
			title: null,
			module: null,
			endbehaviour: null,
			socialform: null,
			method: null,
			material: null,
			teacher_directions: null,
			note:'',
			userfiles: new List<UserFileModel>(),
			modelName:"App\\CustomUserSequence",
		});
	}

	get note():string {
		return this.get<string>( 'note', '' );
	}
	
	set note( n:string ){
		this.set( 'note', n );	
	}
	
	get endbehaviour():string {
		return this.get<string>( 'endbehaviour' );	
	}
	
	set endbehaviour( value:string ){
		this.set( 'endbehaviour', value );	
    }
    
	get teacher_directions():string {
		return this.get<string>( 'teacher_directions' );	
	}
	
    set teacher_directions( value:string ){
		this.set( 'teacher_directions', value );	
    }
    
	get method():string {
		return this.get<string>( 'method' );	
	}
	
	set method( value:string ){
		this.set( 'method', value );	
    }
    
	get socialform():string {
		return this.get<string>( 'socialform' );	
	}
	
	set socialform( value:string ){
		this.set( 'socialform', value );	
    }
    
	get material():string {
		return this.get<string>( 'material' );	
	}
	
	set material( value:string ){
		this.set( 'material', value );	
	}

	get userfiles():List<UserFileModel>{
		return this.get<List<UserFileModel>>( 'userfiles' );
	}

	set userfiles( userfiles:List<UserFileModel> ){
		this.set( 'userfiles', userfiles );
	}

	get slides():List<ISlide>{
		return this.get<List<ISlide>>( 'slides' );
	}

	set slides( slides:List<ISlide> ){
		this.set( 'slides', slides );
	}


}

export default CustomUserSequenceModel;


backend.mapper.toModel.add( 'App\\CustomUserSequence', function( json:any ) {
		
	var sequence = new CustomUserSequenceModel( json );
	
	sequence.userfiles = new List<UserFileModel>( json.userfiles );

	return sequence;	
});

backend.mapper.toJson.add( 'App\\CustomUserSequence', function( model:CustomUserSequenceModel){
	var clone = model.object();
	clone['userfiles'] = model.userfiles ? backend.mapper.json( model.userfiles.all() ) : [];
	return clone;
});